import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
// styles
import styles from './MovingBlobs.mod.css';

const colors = [
  '#BF7FE7',
  '#7F90E7',
  '#7FE7AB',
  '#E9E23D',
  '#E77FAB',
  '#7FC8E7',
  '#7FE7D4',
  '#E7AB7F'
];

class MovingBlobs extends PureComponent {
  render() {
    const { blobs } = this.props;

    return (
      <div className={styles.container}>
        {[...Array(10)].map((circle, index) => {
          const colorIndex = Math.round(Math.random() * colors.length);
          const fillColor = colors[colorIndex];
          const size = Math.floor(Math.random() * 200 + 25);

          return (
            <svg
              key={index}
              className={styles.circle}
              style={{
                top: `${Math.random() * 90 + 10}%`,
                left: `${Math.random() * 100}%`,
                opacity: Number(blobs)
              }}
              width={size}
              height={size}
              viewBox="0 0 150 150"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="75"
                cy="75"
                r="75"
                fill={fillColor}
                fillOpacity={Math.random() * 0.1 + 0.1}
                strokeWidth="0"
              />
            </svg>
          );
        })}
      </div>
    );
  }
}

export default withRouter(MovingBlobs);



// WEBPACK FOOTER //
// ./src/components/Background/MovingBlobs.js